import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import { SettingsProvider, useSettings } from "@/context/AppSettings";
import { LangProvider } from "@/i18n/LangContext";
import { RouteSeo } from "@/components/RouteSeo";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import ClientInformation from "@/pages/ClientInformation";
import SeoServicePage from "@/pages/SeoServicePage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <SettingsProvider>
        <LangProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="bottom-right" richColors />
            <RouteSeo />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gold-brokerage-dubai" element={<SeoServicePage />} />
              <Route path="/sblc-escrow-gold-brokerage-dubai" element={<SeoServicePage />} />
              <Route path="/petroleum-brokerage-dubai" element={<SeoServicePage />} />
              <Route path="/kyc-aml-commercial-brokerage" element={<SeoServicePage />} />
              <Route path="/gold-petroleum-transaction-process" element={<SeoServicePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/desk-047" element={<Admin />} />
              <Route path="/client-information/:token" element={<ClientInformation />} />
            </Routes>
          </BrowserRouter>
        </LangProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
